import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import { Footer } from "../Footer";

const NotFound = () => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "75vh",
      textAlign: "center",
      backgroundColor: "#f4f4f9",
      color: "#333",
      fontFamily: "Arial, sans-serif",
    },
    heading: {
      fontSize: "5rem",
      fontWeight: "bold",
      marginBottom: "1rem",
      color: "#ff6f61",
    },
    text: {
      fontSize: "1.5rem",
      marginBottom: "2rem",
    },
    link: {
      padding: "0.75rem 1.5rem",
      fontSize: "1rem",
      backgroundColor: "#007bff",
      color: "#fff",
      textDecoration: "none",
      borderRadius: "5px",
      transition: "background-color 0.3s",
    },
    linkHover: {
      backgroundColor: "#0056b3",
    },
  };
  return (
    // <div style={{ textAlign: 'center', marginTop: '50px' }}>
    //   <h1>404</h1>
    //   <p>Oops! The page you are looking for does not exist.</p>
    //   <Link to="/" style={{ color: 'blue', textDecoration: 'underline' }}>
    //     Go Back to Home
    //   </Link>
    // </div>/
    <>
      <Header />
      <div style={styles.container}>
        <h1 style={styles.heading}>404</h1>
        <p style={styles.text}>
          Oops! The page you're looking for doesn't exist.
        </p>
        <Link
          to="/"
          style={styles.link}
          onMouseOver={(e) =>
            (e.target.style.backgroundColor = styles.linkHover.backgroundColor)
          }
          onMouseOut={(e) =>
            (e.target.style.backgroundColor = styles.link.backgroundColor)
          }
        >
          Go Back to Home
        </Link>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
